<template>
    <v-container>
        <v-card>
            <v-card-title class="pt-1 text-h6">{{text.chatTitle}}</v-card-title>
            <v-card-subtitle class="pb-0">{{text.dataGetDate}}:{{chatMesseges.lastUpdateStr}}</v-card-subtitle>
            <v-card-text ref="chatMessege" style="border:groove 2px #FFFFFF;overflow: scroll;background-color:#90A4AE">
                <v-container class="pt-1 pb-1 d-flex" v-for="messege in chatMesseges.messeges" :key="messege.seqNo">
                    <v-card color="blue-grey lighten-4 mr-1" style="width:6em">
                        {{messege.createUserName}}<br>{{messege.dateMD}}<br>{{messege.dateHM}}
                    </v-card>
                    <v-card color="blue-grey lighten-4" width="100%">
                        <p>{{messege.messege}}</p>
                    </v-card>
                </v-container>
            </v-card-text>
            <v-card-actions ref="chatAction">
                <v-sheet color="blue-grey lighten-3" class="d-flex" width="100%">
                <v-text-field :error="formError" :rules="[messegeRule]" ref="sendMessege" @focus="textBoxOpacity" @blur="blurTextBox" counter="200" autocomplete="off" outlined v-model="inputText" background-color="blue-grey lighten-5"></v-text-field>
                <v-btn @click="messegePost">{{text.inputMemo}}</v-btn>
                </v-sheet>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../lang";
    let text = new lang(0);
    import exceljs, { PaperSize } from "exceljs";
    import fileSaver from "file-saver";
    import {apiRequest} from "../lib/api";
    import * as comm from '../common';
    import * as type from '../types';
    interface vueRefForm extends Vue{
        validate:()=>boolean;
    }
    export default Vue.extend({
        data: () => ({
            text : text.Text,
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
            inputText:"",
            elm:{
                messege:null as null|HTMLElement,
                action:null as null|HTMLElement,
            },
            messegeRule:(value:string)=> (value.length <= 200) || text.Text.messege.textLengthOver,
            formError:null,
            messegeUpdate:false,
            chatGetPolling:0,
            chatMesseges:{
                lastUpdate:null as Date|null,
                lastUpdateStr:"",
                maxSeq:0,
                messeges:[] as Array<type.ecChat&{dateMD:string,dateHM:string}>,
                seqs:[] as Array<number>,
            }
        }),
        props:{
            activeEventId:String,
        },
        mounted(){
            this.api = this.$store.state.apiSaver;
            window.addEventListener('resize',this.checkSize);
            window.addEventListener('scroll',this.checkSize);
            this.elm.messege = this.$refs.chatMessege as HTMLElement;
            this.elm.messege.addEventListener("change",this.checkSize);
            this.elm.action = this.$refs.chatAction as HTMLElement;
            this.elm.action.style.position = "relative";
            const _tgtElm = this.elm.action.children[0] as HTMLElement;
            if(_tgtElm){
                _tgtElm.style.alignItems = "center";
            }
            this.messegeUpdate = true;
            this.checkSize();
            this.pollingGet();
        },
        updated(){
            if(this.messegeUpdate){
                this.messegeUpdate = false;
                this.checkSize();
            }
        },
        beforeDestroy(){
            if(this.chatGetPolling){
                clearTimeout(this.chatGetPolling);
            }
        },
        methods:{
            pollingGet(){
                this.messegeUpdate = true;
                this.getMesseges();
                this.chatGetPolling = window.setTimeout(this.pollingGet,60000);
            },
            async getMesseges(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const apiResponse = await this.api.apiRequest.request.getEcChat(this.activeEventId,this.chatMesseges.maxSeq);
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200){
                        const messeges = apiResponse.data;
                        if(messeges){
                            for(const mes of messeges.filter(v=>{if(this.chatMesseges.seqs.includes(v.seqNo)){return false}else{return true}})){
                                this.chatMesseges.messeges.unshift(Object.assign(mes,{"dateMD":comm.formatDate(new Date(mes.createDate),'mm/dd'),"dateHM":comm.formatDate(new Date(mes.createDate),'HH:MM')}));
                                this.chatMesseges.seqs.push(mes.seqNo);
                                this.chatMesseges.maxSeq = this.chatMesseges.maxSeq<mes.seqNo?mes.seqNo:this.chatMesseges.maxSeq;
                            }
                        }
                        this.chatMesseges.messeges.sort((a,b)=>{
                            return b.seqNo - a.seqNo;
                        });
                        this.chatMesseges.lastUpdate = new Date();
                        this.chatMesseges.lastUpdateStr = comm.formatDate(this.chatMesseges.lastUpdate,"mm/dd HH:MM:SS");
                        this.inputText = "";
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }else{
                    comm.ApiErrorMessege(this,comm.unknowError);
                }
            },
            async messegePost(){
                const refForm = this.$refs.sendMessege as vueRefForm;
                if(!refForm.validate()){
                    return false;
                }
                if(this.inputText.length === 0){
                    return false;
                }
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const apiResponse = await this.api.apiRequest.request.postEcChat(this.activeEventId,this.inputText);
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200){
                        this.messegeUpdate = true;
                        this.getMesseges();
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }else{
                    comm.ApiErrorMessege(this,comm.unknowError);
                }
            },
            blurTextBox(){
                if(this.elm.action && this.inputText.length === 0){
                    this.checkSize();
                }    
            },
            textBoxOpacity(){
                if(this.elm.action){
                    this.elm.action.style.opacity = '100%';
                }    
            },
            checkSize(){
                if(this.elm.action){
                    this.elm.action.style.bottom = '0px'
                    const actionBoxOffset = this.elm.action.getBoundingClientRect().bottom - document.documentElement.clientHeight;
                    this.elm.action.style.bottom = actionBoxOffset>0?`${actionBoxOffset.toString()}px`:'0px';
                    this.elm.action.style.opacity = actionBoxOffset>0?'70%':'100%';
                }
                if(this.elm.messege){
                    this.elm.messege.style.maxHeight = 'none';
                    const messegeAreaBox = this.elm.messege.getBoundingClientRect();
                    const messegeHeightOffset = messegeAreaBox.bottom - document.documentElement.clientHeight;
                    this.elm.messege.style.maxHeight = messegeHeightOffset>0?`${messegeAreaBox.height-messegeHeightOffset}px`:"none";
                }
            }
        }
    })

</script>